import { __assign, __rest } from "tslib";
import * as React from 'react';
import { default as Combobox } from './Combobox';
import { useCreatable } from './useCreatable';
import { CreatableMenuItem } from './CreatableCombobox';
import { useAsync } from './useAsync';
export var AsyncCreatableCombobox = function (props, ref) {
    var components = props.components, consumerProps = __rest(props, ["components"]);
    var createOptionLabel = consumerProps.strings.createOptionLabel;
    /**
     * The order is important here.
     * We start by providing the consumer props to the useAsync hook.
     * useAsync will begin the fetch if detaultOptions is true.
     * While fetching options:
     *  - The loading status is updated in the props and passed from useAsync to useCreatable.
     *  - useCreatable has no options at this time and passes the props to Combobox.
     * Once options are fetched:
     *  - The options and loading status are updated in the props and passed to useCreatable.
     *  - useCreatable updates the options prop if a creatable option is needed.
     *  - The props are provided to Combobox.
     */
    // eslint-disable-next-line react/no-unstable-nested-components
    var AsyncCreatable = function (props) { return (React.createElement(Combobox, __assign({}, useCreatable(useAsync(props))))); };
    return (React.createElement(AsyncCreatable, __assign({ ref: ref, components: __assign(__assign({}, components), { 
            // eslint-disable-next-line react/no-unstable-nested-components
            MenuItem: function (props) { return (React.createElement(CreatableMenuItem, __assign({ createOptionLabel: createOptionLabel, components: components }, props))); } }) }, consumerProps)));
};
var AsyncCreatableComboboxRef = React.forwardRef(AsyncCreatableCombobox);
export default AsyncCreatableComboboxRef;
//# sourceMappingURL=AsyncCreatableCombobox.js.map